import { createFileRoute } from '@tanstack/react-router'
import { CostEntryDetailPage } from '../../../../features/projects/cost-entry-pages'

export const Route = createFileRoute('/_app/projects/cost-entries/$entryId')({
  component: CostEntryDetailPage,
})
